'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState, } from 'react';
import { useMediaQuery } from 'react-responsive';
import { ThemeProvider } from 'styled-components';
import { GlobalTypographyStyling } from '../../theme/global-style';
import { LocaleProvider } from './locale-provider';
const initialLogos = {
    client: '',
    provider: '',
    admin: '',
    'grant-provider': '',
    portfolio: '',
    default: '',
    compass: '',
};
export const PlatformContext = React.createContext({
    app: 'website',
    contentfulClient: undefined,
    contentfulClient2: undefined,
    fallbackLogos: initialLogos,
    addFallbackLogo: (_logo, _type) => { },
    isDev: false,
    paths: {},
    menuOpen: false,
    toggleMenu: function () {
        throw new Error('Function not implemented.');
    },
});
PlatformContext.displayName = 'PlatformContext';
const environment = process.env.NODE_ENV;
const isDev = environment === 'development';
const adminPaths = {
    grants: '/funding-explorer',
};
const clientPaths = {
    grants: '/funding-explorer',
};
const partnerPaths = {
    grants: '/',
};
const PlatformProvider = ({ children, app, contentfulClient, contentfulClient2, defaultFallbackLogos, theme, }) => {
    const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.tablet });
    const [menuOpen, setMenuOpen] = useState(false);
    const toggleMenu = useCallback(() => setMenuOpen((isOpen) => !isOpen), []);
    useEffect(() => {
        if (!isTablet)
            setMenuOpen(false);
    }, [isTablet]);
    const fallbackLogosRef = useRef(defaultFallbackLogos !== null && defaultFallbackLogos !== void 0 ? defaultFallbackLogos : initialLogos);
    const addFallbackLogo = useCallback((logo, type) => {
        fallbackLogosRef.current = Object.assign(Object.assign({}, fallbackLogosRef.current), { [type]: logo });
    }, []);
    const paths = useMemo(() => app === 'admin'
        ? adminPaths
        : app === 'provider'
            ? partnerPaths
            : clientPaths, [app]);
    const contextValue = useMemo(() => ({
        app,
        contentfulClient,
        contentfulClient2,
        fallbackLogos: fallbackLogosRef.current,
        addFallbackLogo,
        isDev,
        paths,
        menuOpen,
        toggleMenu,
    }), [
        addFallbackLogo,
        app,
        contentfulClient,
        contentfulClient2,
        menuOpen,
        paths,
        toggleMenu,
    ]);
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(GlobalTypographyStyling, {}), _jsx(LocaleProvider, { children: _jsx(PlatformContext.Provider, { value: contextValue, children: children }) })] }));
};
export const usePlatform = () => useContext(PlatformContext);
export default PlatformProvider;
